import React from 'react'
import ActionUiHandler from '@ui/template/actionUiHandler/ActionUiHandler'
import NotFound from '@ui/notFound/NotFound'
import {useGetVideoStreamsListQuery} from '@containers/video/videoStreams/queryHooks/useVideoStreamsQuery'
import {VideoStreamsList} from '@containers/video/videoStreams/list/VideoStreamsList'
import {useAppContext} from '@context/appContext/hooks/useAppContext'
import {SxType} from '@baseTypes/sx/sxTypes'

const sx:SxType = {
	height: '100%',
}

const VideoStreamsByAccount = () => {
	
	const {account} = useAppContext()
	
	const {
		data,
		isLoading,
		isFetching,
	} = useGetVideoStreamsListQuery(account.id)
	
	return (
		<ActionUiHandler
			isLoading={isFetching}
			isLoadingWithoutRender={isLoading}
			sx={sx}
		>
			{!data?.length && !isLoading && !isFetching && <NotFound/>}
			
			<VideoStreamsList
				videoStreams={data || []}
				accountId={account.id}
			/>
		</ActionUiHandler>
	)
}

export default VideoStreamsByAccount